import { render, staticRenderFns } from "./AccountMergeSelection.vue?vue&type=template&id=7b85b9fc&scoped=true&"
import script from "./AccountMergeSelection.vue?vue&type=script&lang=js&"
export * from "./AccountMergeSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b85b9fc",
  null
  
)

export default component.exports